import { render, staticRenderFns } from "./DeliverCard.vue?vue&type=template&id=d3678b42&scoped=true"
import script from "./DeliverCard.vue?vue&type=script&lang=js"
export * from "./DeliverCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3678b42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3678b42')) {
      api.createRecord('d3678b42', component.options)
    } else {
      api.reload('d3678b42', component.options)
    }
    module.hot.accept("./DeliverCard.vue?vue&type=template&id=d3678b42&scoped=true", function () {
      api.rerender('d3678b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/DeliverCard.vue"
export default component.exports